(function () {
  const instances = new WeakMap();

  function getRoot(node) {
    if (!node) return null;
    if (node.matches && node.matches('[data-jatajoot-watch-shop]')) return node;
    return node.querySelector ? node.querySelector('[data-jatajoot-watch-shop]') : null;
  }

  function pauseOthers(root, currentVideo) {
    root.querySelectorAll('.jatajoot-watch-shop__media video').forEach(function (video) {
      if (video === currentVideo) return;
      video.pause();
      const card = video.closest('.jatajoot-watch-shop__card');
      if (card) card.classList.remove('is-playing');
    });
  }

  function setPlayingState(card, video, isPlaying) {
    if (card) card.classList.toggle('is-playing', isPlaying);
    const playButton = card && card.querySelector('[data-jws-play]');
    if (playButton) {
      playButton.setAttribute('aria-label', isPlaying ? 'Pause video' : 'Play video');
    }
    if (video) video.setAttribute('aria-hidden', 'false');
  }

  function playVideo(root, video, card, userInitiated) {
    pauseOthers(root, video);
    video.muted = !userInitiated;
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(function () {
        setPlayingState(card, video, false);
      });
    }
  }

  function initRoot(root) {
    if (!root || instances.has(root)) return;

    const cards = Array.from(root.querySelectorAll('.jatajoot-watch-shop__card'));
    const videos = [];
    const cleanups = [];
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function initPagination() {
      const sliderComponent = root.querySelector('slider-component');
      const slider = root.querySelector('[id^="Slider-"]');
      const slides = Array.from(root.querySelectorAll('[id^="Slide-"]'));
      const radios = Array.from(root.querySelectorAll('.jatajoot-watch-shop__pagination input[type="radio"]'));
      if (!slider || radios.length < 2) return;

      let ticking = false;

      function currentIndex() {
        const offset = sliderComponent && sliderComponent.sliderItemOffset;
        if (offset) {
          return Math.max(0, Math.min(slides.length - 1, Math.round(slider.scrollLeft / offset)));
        }

        let closest = 0;
        let closestDist = Infinity;
        slides.forEach(function (slide, index) {
          const dist = Math.abs(slide.offsetLeft - slider.scrollLeft);
          if (dist < closestDist) {
            closestDist = dist;
            closest = index;
          }
        });
        return closest;
      }

      function syncRadios() {
        const index = currentIndex();
        radios.forEach(function (radio, radioIndex) {
          radio.checked = radioIndex === index;
        });
      }

      radios.forEach(function (radio) {
        const onChange = function () {
          if (!radio.checked) return;
          const index = parseInt(radio.getAttribute('data-jws-index'), 10);
          const slide = slides[index];
          if (!slide) return;
          slider.scrollTo({
            left: slide.offsetLeft,
            behavior: reduceMotion ? 'auto' : 'smooth',
          });
        };
        radio.addEventListener('change', onChange);
        cleanups.push(function () {
          radio.removeEventListener('change', onChange);
        });
      });

      const onScroll = function () {
        if (ticking) return;
        ticking = true;
        window.requestAnimationFrame(function () {
          syncRadios();
          ticking = false;
        });
      };
      slider.addEventListener('scroll', onScroll, { passive: true });
      cleanups.push(function () {
        slider.removeEventListener('scroll', onScroll);
      });
    }

    initPagination();

    cards.forEach(function (card) {
      const video = card.querySelector('.jatajoot-watch-shop__media video');
      const playButton = card.querySelector('[data-jws-play]');
      if (!video || !playButton) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      videos.push(video);

      const onPlay = function () {
        setPlayingState(card, video, true);
      };
      const onPause = function () {
        setPlayingState(card, video, false);
      };
      const onEnded = function () {
        setPlayingState(card, video, false);
      };
      const onToggle = function (event) {
        event.preventDefault();
        if (video.paused) {
          playVideo(root, video, card, true);
        } else {
          video.pause();
        }
      };

      video.addEventListener('play', onPlay);
      video.addEventListener('pause', onPause);
      video.addEventListener('ended', onEnded);
      playButton.addEventListener('click', onToggle);

      cleanups.push(function () {
        video.removeEventListener('play', onPlay);
        video.removeEventListener('pause', onPause);
        video.removeEventListener('ended', onEnded);
        playButton.removeEventListener('click', onToggle);
      });
    });

    let observer = null;
    if (!reduceMotion && 'IntersectionObserver' in window && videos[0]) {
      let didAutoplay = false;
      observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || didAutoplay) return;
            didAutoplay = true;
            playVideo(root, entry.target, entry.target.closest('.jatajoot-watch-shop__card'), false);
            observer.disconnect();
          });
        },
        { threshold: 0.55 }
      );
      observer.observe(videos[0]);
    }

    instances.set(root, {
      destroy: function () {
        if (observer) observer.disconnect();
        cleanups.forEach(function (cleanup) {
          cleanup();
        });
        videos.forEach(function (video) {
          video.pause();
        });
      },
    });
  }

  function destroyRoot(root) {
    const instance = root && instances.get(root);
    if (!instance) return;
    instance.destroy();
    instances.delete(root);
  }

  function initAll(scope) {
    const context = scope || document;
    if (!context.querySelectorAll) return;
    context.querySelectorAll('[data-jatajoot-watch-shop]').forEach(initRoot);
  }

  document.addEventListener('shopify:section:load', function (event) {
    const root = getRoot(event.target);
    if (root) initRoot(root);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const root = getRoot(event.target);
    if (root) destroyRoot(root);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }
})();
